// // src/context/ProgressContext.js
// import React, { createContext, useState } from 'react';
// const ProgressContext = createContext();
// export const ProgressProvider = ({ children }) => {
//   const steps = [
//     { label: 'Customer Segmentation', path: '/dashboard/customer-segmentation' },
//     { label: 'Agent Strategy', path: '/dashboard/agent-strategy' },
//     { label: 'Product Recommendation', path: '/dashboard/product-recommendation' },
//     { label: 'EBI Generation', path: '/dashboard/ebi-generation' },
//     { label: 'Product Comparison', path: '/dashboard/product-comparison' },
//     { label: 'Summary Creation', path: '/dashboard/summary-creation' },
//   ];
//   const [currentStep, setCurrentStep] = useState(0);
//   const [completedSteps, setCompletedSteps] = useState([]);
//   const nextStep = () => {
//     // Mark the current step as completed
//     setCompletedSteps((prevCompleted) => {
//       if (!prevCompleted.includes(currentStep)) {
//         return [...prevCompleted, currentStep];
//       }
//       return prevCompleted;
//     });
//     // Move to the next step
//     setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
//   };
//   const goToStep = (stepIndex) => {
//     setCurrentStep(stepIndex);
//   };
//   return (
//     <ProgressContext.Provider
//       value={{
//         steps,
//         currentStep,
//         completedSteps,
//         nextStep,
//         goToStep,
//         setCurrentStep,
//       }}
//     >
//       {children}
//     </ProgressContext.Provider>
//   );
// };
// export default ProgressContext;





// src/context/ProgressContext.js
import React, { createContext, useState } from 'react';
const ProgressContext = createContext();
export const ProgressProvider = ({ children }) => {
  // Steps WITHOUT Agent Strategy
  const steps = [
    { label: 'Customer Segmentation', path: '/dashboard/customer-segmentation' },
    { label: 'Product Recommendation', path: '/dashboard/product-recommendation' },
    { label: 'EBI Generation', path: '/dashboard/ebi-generation' },
    { label: 'Product Comparison', path: '/dashboard/product-comparison' },
    { label: 'Summary Creation', path: '/dashboard/summary-creation' },
  ];
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);
  const nextStep = () => {
    // Mark the current step as completed
    setCompletedSteps((prevCompleted) => {
      if (!prevCompleted.includes(currentStep)) {
        return [...prevCompleted, currentStep];
      }
      return prevCompleted;
    });
    // Move to next
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
  };
  const goToStep = (stepIndex) => {
    setCurrentStep(stepIndex);
  };
  return (
    <ProgressContext.Provider
      value={{
        steps,
        currentStep,
        completedSteps,
        nextStep,
        goToStep,
        setCurrentStep,
      }}
    >
      {children}
    </ProgressContext.Provider>
  );
};
export default ProgressContext;
